import script from "./bold-options-group.vue?vue&type=script&setup=true&lang=js"
export * from "./bold-options-group.vue?vue&type=script&setup=true&lang=js"

import "./bold-options-group.vue?vue&type=style&index=0&id=1aa21b88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aa21b88"]])

export default __exports__